import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JobPositionModel } from '../model/job-position.model';
import { JobPositionService } from '../job-position.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-job-position-edit',
  templateUrl: './job-position-edit.component.html',
  styleUrls: ['./job-position-edit.component.scss'],
  standalone: false
})
export class JobPositionEditComponent implements DirtyCheck {
  title: string = "New Job Position";
  editForm: FormGroup;
  jobPositionInfo: JobPositionModel = {};
  isFormDirty: boolean = false;
  permission: any;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private jobPositionService: JobPositionService,
    private snackBarService: SnackBarService,
    private permissionService: PermissionService
  ) {
    let id = this.route.snapshot.paramMap.get('id');
    this.editForm = this.builder.group({
      code: [this.jobPositionInfo.code, [Validators.required, Validators.maxLength(50)]],
      name: [this.jobPositionInfo.name, [Validators.required, Validators.maxLength(100)]],
      description: [this.jobPositionInfo.description],
      hierarchy_order: [this.jobPositionInfo.hierarchy_order || 0, [Validators.required]],
      grade: [this.jobPositionInfo.grade, [Validators.min(0)]],
      fg_color: [this.jobPositionInfo.fg_color || '#000000'],
      bg_color: [this.jobPositionInfo.bg_color || '#ffffff'],
      is_hq: [{ value: false, disabled: true }],
      is_active: [{ value: true, disabled: true }],
      receive_roster_by_mail: [false]
    });

    this.editForm.valueChanges.subscribe(() => {
      this.isFormDirty = true;
    });

    if (id !== null && parseInt(id) !== 0) {
      this.setJobPositionInfo(id);
    }
    this.permission = this.permissionService.getRowPermission(this.permissionService.getPagePermission("job-position"), id);
  }

  isDirty(): boolean {
    return this.isFormDirty;
  }

  navBack(): void {
    this.router.navigate(['/system/job-position']);
  }

  setJobPositionInfo(id: any): void {
    this.jobPositionService.getJobPositionById(id).subscribe({
      next: (response) => {
        if (response.status == 'SUCCESS') {
          this.jobPositionInfo = response.data.job_position;
          
          const isHq = Number(this.jobPositionInfo.is_hq) === 1;
          const isActive = this.jobPositionInfo.is_active === undefined || Number(this.jobPositionInfo.is_active) === 1;
          const receiveRoster = Number(this.jobPositionInfo.receive_roster_by_mail) === 1;

          this.editForm.patchValue({
            ...this.jobPositionInfo,
            is_hq: isHq,
            is_active: isActive,
            receive_roster_by_mail: receiveRoster
          });
          this.title = this.getTitle();
          this.isFormDirty = false;
        } else {
          this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
        }
      }
    });
  }

  getTitle(): string {
    return (!this.jobPositionInfo.id || this.jobPositionInfo.id == 0) ? "New Job Position" : "Editing : " + this.jobPositionInfo.name;
  }

  save(): void {
    if (this.editForm.valid) {
      const formValue = { ...this.editForm.value };
      formValue.receive_roster_by_mail = formValue.receive_roster_by_mail ? 1 : 0;
      Object.assign(this.jobPositionInfo, formValue);
      this.jobPositionService.update(this.jobPositionInfo).subscribe({
        next: (response) => {
          if (response.status == 'SUCCESS') {
            this.isFormDirty = false;
            this.snackBarService.openSnackBar({
              type: 'success',
              title: 'Saved',
              message: `Record for ${this.jobPositionInfo.name} has been updated successfully.`
            });
            this.router.navigate(['/system/job-position']);
          } else {
            this.snackBarService.openSnackBar({ message: response.message, title: 'Failed!!!', type: 'error' });
          }
        }
      });
    } else {
      this.editForm.markAllAsTouched();
    }
  }
}
